export const MAX_HEIGHT = 600;
export const ASPECT_RATIO = 9 / 7;
export const OUTER_PIECE_THICKNESS = 2.88;
